// extracted by mini-css-extract-plugin
export var layoutContainer = "_4r-0";
export var layoutContainerNoRounding = "_4r-6";
export var layoutContainerOpen = "_4r-5";
export var layoutContainerResizing = "_4r-1";
export var mainContent = "_4r-2";
export var resizeDivider = "_4r-3";
export var slidePanel = "_4r-4";